
export const clinical = {
  dashboard: {
    loading: "กำลังโหลดข้อมูล...",
    title: "ภาพรวมคลินิก",
    subtitle: "สรุปยอดผู้ป่วยและการใช้งานแพ็กเกจ",
    systemStatus: "ระบบทำงานปกติ",
    kpi: {
      netSales: "ยอดขายสุทธิ",
      grossSales: "ยอดขายรวม"
    },
    filters: {
      today: "วันนี้",
      last7days: "7 วันย้อนหลัง",
      last30days: "30 วันย้อนหลัง"
    },
    table: {
      title: "สรุปรายวัน",
      date: "วันที่"
    },
    planUsage: {
      title: "สถานะแพ็กเกจ (Plan Usage)",
      caseLimit: "โควต้าการรักษา (Case Limit)",
      currentPlan: "แพ็กเกจปัจจุบัน",
      resetDate: "รีเซ็ตทุกวันที่ 1 ของเดือน"
    },
    quickActions: {
      title: "เมนูลัด (Quick Actions)",
      registerPatient: "ลงทะเบียนผู้ป่วย",
      doctorStation: "ห้องตรวจแพทย์"
    }
  },
  customerManagement: {
    title: "ทะเบียนผู้ป่วย",
    addNew: "ลงทะเบียนผู้ป่วยใหม่",
    loading: "กำลังโหลดรายชื่อ...",
    errorTitle: "ข้อผิดพลาด",
    errorMessage: "ไม่สามารถโหลดข้อมูลผู้ป่วยได้",
    deleteConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลผู้ป่วยนี้?",
    customerSince: "เป็นสมาชิกเมื่อ {{date}}",
    edit: "แก้ไขข้อมูล",
    delete: "ลบ",
    profileTab: "ข้อมูลทั่วไป",
    prescriptionsTab: "ประวัติการรักษา & โควต้า",
    empty: "ไม่พบข้อมูลผู้ป่วย",
    table: {
      name: "ชื่อ-สกุล",
      phone: "เบอร์โทร",
      nationalId: "เลขบัตร ปชช.",
      dob: "วันเกิด",
      actions: "จัดการ"
    }
  },
  telemedicine: {
    commandCenter: "ห้องตรวจแพทย์",
    subtitle: "ติดตามคิวผู้ป่วยและอนุมัติใบสั่งยา",
    systemOnline: "ระบบออนไลน์",
    waitingRoom: "ห้องรอตรวจ",
    refresh: "รีเฟรช",
    store: "สาขา",
    call: "วิดีโอคอล",
    reviewSign: "ตรวจและเซ็นชื่อ",
    empty: {
      title: "ไม่มีคิวรอตรวจ",
      subtitle: "ขณะนี้ยังไม่มีผู้ป่วยลงทะเบียนเข้ามา"
    }
  }
};
